<template>
  <div>
    <div class="item-cost item-repr" v-if="work_repr('sale_status')=='sale'" :title="$t('message.WorkSaleRepr')">
      <span class="item-summ">
        <template v-if="work_repr('currency')=='usd'">$ </template>
        <template v-if="work_repr('currency')=='euro'">€ </template>
        {{show_price(work_repr('price'))}}
        <template v-if="work_repr('currency')=='rur'"> ₽</template>
        <template v-if="work_repr('currency')=='uah'"> ₴</template>
      </span>
    </div>

    <div class="item-cost" v-if="work.status.sale_status=='sale'" :title="$t('message.WorkSaleOriginal')">
      <template v-if="work.status.price_hidden=='y'">
        <span v-if="work.status.visibility=='subscribers' && is_subdomain!='1'" class="item-summ">
          {{$t("message.VSubscribers")}}
        </span>
        <span v-if="work.status.visibility=='subscribers' && is_subdomain=='1'" class="item-summ">
          {{$t("message.VRequest")}} <!-- на субдоменах нет подписчиков -->
        </span>
        <span v-if="work.status.visibility=='request'" class="item-summ">
          {{$t("message.VRequest")}}
        </span>
        <span v-if="work.status.visibility=='hidden'" class="item-summ">
          {{$t("message.VHidden")}}
        </span>
      </template>
      <template v-else>
        <span class="item-summ">
          <template v-if="work.status.currency=='usd'">$ </template>
          <template v-if="work.status.currency=='euro'">€ </template>
          {{show_price(work.status.price)}}
          <template v-if="work.status.currency=='rur'"> ₽</template>
          <template v-if="work.status.currency=='uah'"> ₴</template>
        </span>
      </template>
    </div>

    <div class="item-cost item-green" v-if="(work.status.sale_status=='auction' || work.status.sale_status=='sale') && work.status.is_negotiated=='y'" :title="$t('message.WorkSaleOriginal')">{{$t("message.Negotiated")}}</div>
    <div class="item-cost" v-if="work.status.sale_status=='reserved'" :title="$t('message.WorkSaleOriginal')">{{$t("message.Reserved")}}</div>
    <div class="item-cost" v-if="work.status.sale_status=='sold'" :title="$t('message.WorkSaleOriginal')">{{$t("message.WorkSold")}}</div>
  </div>
</template>

<script>
  import WorksItemCostMix from './WorksItemCostMix'

  export default {
    name: 'works-item-cost',
    mixins: [WorksItemCostMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/WorksItemCost.vue